





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Vehicle } from '../../models';
import { Method, VehicleID } from '../../utils';
import SelectedVehicle from './SelectedVehicle.vue';
import ItemVehicle from './ItemVehicle.vue';

@Component({
    components: { ItemVehicle, SelectedVehicle }
})
export default class AutocompleteVehicles extends Vue {
    @Prop({ default: () => () => [] }) selectedVehicles: Vehicle[];
    @Prop({ default: () => () => console.log('[AutocompleteVehicles] set vehicles') }) selectVehicles: Method<
        VehicleID[],
        void
    >;
    @Prop({ default: () => () => console.log('[AutocompleteVehicles] add selected vehicle') })
    addSelectedVehicle: Method<Vehicle, void>;
    @Prop({ default: () => () => console.log('[AutocompleteVehicles] unSelect vehicles') }) unSelectVehicle: Method<
        Vehicle,
        void
    >;
    @Prop({ default: () => () => [] }) currentVehicles: Vehicle[];
    @Prop({ default: () => () => [] }) isVehicleSelected: Method<VehicleID, boolean>;
    @Prop({ default: () => () => console.log('[AutocompleteVehicles] filter') }) filter: Method<any, boolean>;
    properties = ['id', 'vehicle_plate', 'description', 'vin'];
    values: Vehicle[] = [];

    handleInput(vehicles: Vehicle[]) {
        this.selectVehicles(vehicles.map(vehicle => vehicle.id));
    }

    handleSelectVehicle(vehicle: Vehicle) {
        if (this.selectedVehicles.length < 3) {
            this.addSelectedVehicle(vehicle);
        } else {
            this.$emit('too-many-selected');
        }
    }

    handleUnselectVehicle(vehicle: Vehicle): void {
        this.unSelectVehicle(vehicle);
    }

    get autocomplete(): HTMLFormElement {
        return this.$refs.autocomplete as HTMLFormElement;
    }

    get currentVehiclesFiltered() {
        if (this.isReadonly) {
            return [];
        } else {
            return this.currentVehicles;
        }
    }

    get isReadonly(): boolean {
        return this.selectedVehicles.length >= 3;
    }
}
